// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { BaseResponseVerificationConfig } from '../../types';

/**
 * 查询二次验证
 *
 * @export
 * @tags 租户接口
 * @link [GET] /companys/queryLoginVerification
 */
export function getCompanysQueryLoginVerification(): Promise<BaseResponseVerificationConfig>;
export function getCompanysQueryLoginVerification(
    options: ApiOptions<never, never>
): Promise<BaseResponseVerificationConfig>;
export function getCompanysQueryLoginVerification(
    options?: ApiOptions<never, never>
): Promise<BaseResponseVerificationConfig> {
    return request<never, never, never>('/companys/queryLoginVerification', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getCompanysQueryLoginVerification',
    });
}

export const meta = [
    { tags: ['租户接口'], path: '/companys/queryLoginVerification', method: 'get' },
];
